import {
  RESET_SEARCH_TXN_ACCOUNT_DROPDOWNS,
  RESET_STORED_DEALER_ACCOUNT_IDS,
  RESET_STORED_PARENT_DEALER_ACCOUNT_IDS,
  RESET_STORED_SALESPERSON_NAMES,
} from "../action";

export function resetSearchTxnAccountDropdowns(type) {
  if (type == "storedParentDealerAccountIds") {
    return (dispatch) => {
      dispatch({ type: RESET_STORED_PARENT_DEALER_ACCOUNT_IDS });
    };
  }
  if (type == "storedDealerAccountIds") {
    return (dispatch) => {
      dispatch({ type: RESET_STORED_DEALER_ACCOUNT_IDS });
    };
  }
  if (type == "storedSalesPersonNames") {
    return (dispatch) => {
      dispatch({ type: RESET_STORED_SALESPERSON_NAMES });
    };
  } else {
    return (dispatch) => {
      dispatch({ type: RESET_SEARCH_TXN_ACCOUNT_DROPDOWNS });
    };
  }
}
